import { render } from "./AppPortfolio.vue?vue&type=template&id=240ed4d2"
import script from "./AppPortfolio.vue?vue&type=script&lang=js"
export * from "./AppPortfolio.vue?vue&type=script&lang=js"

import "./AppPortfolio.vue?vue&type=style&index=0&id=240ed4d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__